import { ReactNode } from 'react';

import { CssBaseline, SimplePaletteColorOptions, ThemeProvider } from '@mui/material';

import { useClientContext } from 'context/ClientContext';
import { useCustomFavicon } from 'styles/customFavicon';
import { updateDefaultTheme } from 'styles/defaultTheme';

interface CustomThemeProps {
    children?: ReactNode;
}

/**
 * Cria o themeProvider aplicando o tema personalizado + baseline
 * @param children
 * @returns base do sistema com tema + baseline aplicado
 */
export function CustomTheme({ children }: CustomThemeProps) {
    const { theme } = useClientContext();
    const customTheme = updateDefaultTheme(theme || {});
    const secondaryColor = (theme?.palette?.secondary as SimplePaletteColorOptions)?.main;

    if (secondaryColor) {
        document.body.style.backgroundColor = secondaryColor;
    }

    useCustomFavicon();

    return (
        <ThemeProvider theme={customTheme}>
            <CssBaseline />
            {children}
        </ThemeProvider>
    );
}
